/* app/ui/header/sticky */

define(
	'app/ui/header/sticky',[
		'jquery',
		'pubsub'
	],
	function($) {

		var Module;

		var classes;

		var $window;
		var $body;
		var $header;
		var headerHeight;
		var didScroll;
		var lastScrollTop = 0;
		var delta = 5;

		return {
			init: function($dadBod, classList) {
				Module = this;
				$body = $dadBod;
				classes = classList;

				Module._initElements();
				Module._initSubscriptions();
				Module._setListener();

				if ($(window).scrollTop() === 0) {
					Module._setSticky();
				}
			},

			_initElements: function() {
				$window = $(window);
				$header = $('.js-header');
				headerHeight = $header.outerHeight();
			},

			_initSubscriptions: function() {
				$.subscribe('/window/scroll', Module._setDidScroll);
				$.subscribe('/header/hide', Module._hideHeader);
			},

			_setListener: function() {

				setInterval(
					function() {
						if (didScroll) {
							Module._hasScrolled();
							didScroll = false;
						}
					},
					250
				);
			},

			_setDidScroll: function() {
				didScroll = true;
			},

			_isSticky: function () {
				var isSticky = $header.hasClass(classes.sticky);
				return isSticky;
			},

			_setSticky: function () {
				if (Module._isSticky() === false) {
					$header.addClass(classes.sticky);
				}
			},

			_hideHeader: function() {
				$header.removeClass(classes.headerDown).addClass(classes.headerUp);
			},

			_hasScrolled: function() {
				var scrollTop = $window.scrollTop();

				// Make sure they scroll more than delta
				if (Math.abs(lastScrollTop - scrollTop) <= delta || $body.hasClass(classes.dropdownOpen)) {
					return false;
				}

				// If they scrolled down and are past the navbar, add class .nav-up.
				// This is necessary so you never see what is "behind" the navbar.
				if (scrollTop > lastScrollTop && scrollTop > headerHeight) {
					// Scroll Down
					$header.addClass(classes.headerUp);
					$header.removeClass(classes.headerDown);

					if (Module._isSticky() === false) {
						window.setTimeout(Module._setSticky, 250);
					}
				} else {
					// Scroll Up
					if (scrollTop + $window.height() < $(document).height()) {

						Module._setSticky();

						if (scrollTop > headerHeight) {
							$header.addClass(classes.headerDown);
						} else {
							$header.removeClass(classes.headerDown);
						}

						$header.removeClass(classes.headerUp);
					}
				}

				lastScrollTop = scrollTop;
			}
		}
	}
);
